module.exports = __webpack_public_path__ + "img/hair_back_male_spiked.1b63a8e8.png";